import Resource from '@/api/Resource';

export default class extends Resource {
  $name = 'tags';

  $defaults() {
    return {
      id: null,
      is_active: true,
      status_label: 'активна',
      name: '',
      color: '',
      created_at: null,
    };
  }

  get colors() {
    return [
      'is-primary',
      'is-primary is-light',
      'is-success',
      'is-success is-light',
      'is-danger',
      'is-danger is-light',
      'is-warning',
      'is-warning is-light',
      'is-info',
      'is-info is-light',
      'is-link',
      'is-link is-light',
      'is-light',
      'is-dark',
    ];
  }
}
